import { environment } from "../environment";

export interface EnvironmentType {
  isTactical: boolean;
  isCommercial: boolean;
}

export const useEnvironmentType = (): EnvironmentType => {
  const envType = environment.VITE_ENV_TYPE;

  return {
    isTactical: envType === "tactical",
    isCommercial: envType !== "tactical",
  };
};
